import { useContext } from 'react';

import { LayoutViewContext } from './LayoutViewContext';

const useLayoutViewContext = () => {
  const context = useContext(LayoutViewContext);

  if (!context) {
    throw new Error('useLayoutViewContext must be used within LayoutViewContextProvider');
  }

  return context;
};

export { useLayoutViewContext };
